// New tagged slice for the migrated `_features/systemFeatures` feature -
// consolidates TWO duplicate injectEndpoints calls that both existed on
// the same apiSlice for /feature routes (the old tree's `features/api/
// featureSlice.js` and `features/SystemFeature/api/systemFeatureApi.js` -
// that whole tree has since been fully retired).
//
// Unlike Billing Units/Usage Compilation, no live bug was found here -
// confirmed directly against simplifyserver/routes/feature.js and
// controllers/feature.controller.js that every endpoint below already
// matched a real backend route with the right body/param shape in both
// originals. This is a clean consolidation, closer to Usage Sources'
// "confirmed benign" pass (docs/bug-sheet.md #102).
//
// Drops deleteSystemFeature - defined in both originals, exported by
// neither's public hook surface, zero UI consumers (archive/activate uses
// changeSystemFeatureStatus), same dead-endpoint pattern as every prior
// migration.
import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const systemFeatureApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllSystemFeatures: builder.query({
      query: (params) => ({
        url: apiRoutes.feature.get.path,
        method: apiRoutes.feature.get.reqType,
        params,
      }),
      providesTags: ["SystemFeatures"],
    }),
    getSystemFeatures: builder.query({
      query: (params) => ({
        url: apiRoutes.feature.getAll.path,
        method: apiRoutes.feature.getAll.reqType,
        params,
      }),
      providesTags: ["SystemFeatures"],
    }),
    createSystemFeature: builder.mutation({
      query: (data) => ({
        url: apiRoutes.feature.create.path,
        method: apiRoutes.feature.create.reqType,
        body: data,
      }),
      invalidatesTags: ["SystemFeatures"],
    }),
    editSystemFeature: builder.mutation({
      query: (data) => ({
        url: apiRoutes.feature.edit.path,
        method: apiRoutes.feature.edit.reqType,
        body: data,
      }),
      invalidatesTags: ["SystemFeatures"],
    }),
    changeSystemFeatureStatus: builder.mutation({
      query: (data) => ({
        url: `${apiRoutes.feature.edit.path}changeStatus`,
        method: apiRoutes.feature.edit.reqType,
        body: data,
      }),
      invalidatesTags: ["SystemFeatures"],
    }),
  }),
});

export const {
  useGetAllSystemFeaturesQuery,
  useGetSystemFeaturesQuery,
  useCreateSystemFeatureMutation,
  useEditSystemFeatureMutation,
  useChangeSystemFeatureStatusMutation,
} = systemFeatureApi;
